import React from 'react';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getString } from 'app/api/redux-watson/watson-config-selectors';

function BrandedDocumentTitle({ title, brandName, children }) {
  let fullTitle = '';
  if (title && brandName) {
    fullTitle = `${brandName}: ${title}`;
  } else if (brandName) {
    fullTitle = brandName;
  } else if (title) {
    fullTitle = title;
  }
  return <DocumentTitle title={fullTitle}>{children}</DocumentTitle>;
}

BrandedDocumentTitle.defaultProps = {
  brandName: '',
};

BrandedDocumentTitle.propTypes = {
  brandName: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.element.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  title: ownProps.titleId ? getString(state, ownProps.titleId) : ownProps.title,
});

export default connect(mapStateToProps)(BrandedDocumentTitle);



// WEBPACK FOOTER //
// ./src/app/ui/core/common/BrandedDocumentTitle.js